module.exports = __webpack_public_path__ + "b917c3be5547bbf30e780659fc6a395c.jpg";